import { InputGroup, Form, Button } from "react-bootstrap";
import axios from "axios";
import React, { useState, useRef, useEffect, useCallback } from "react";




function EmailVaildator(props) {
    
    
    const [inputEmail, setInputEmail] = useState("");
    const [emailData, setEmailData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [isVaildMail, setIsVaildMail] = useState("")
    const [serviceType, setServiceType] = useState("")
    const [emailError, setEmailError] = useState("")
    const [dailyQuotaError, setDailyQuotaError] = useState(true)
    
    const baseUrl = "https://app.engagebay.com/jsapi/rest/"
    const authKey = "ktb76s1540fl2hnhbqnrtd2npb"

    // const baseUrl = "http://localhost:8888/jsapi/rest/"
    // const authKey = "jgr7ioil3ltv4ak2fb5ssdkvi3"
    const ref = useRef()
   
    //const submitFormFn = this.props.submitForm;
    
    useEffect(() => {
        
        ref.current.focus();
    }, []);

    
    

   async function handleData() {
       
   
        setEmailData([""])
        setDailyQuotaError(true)
       

        if (/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(inputEmail)) {
            setIsLoading(true)
            if(props.token==="")
                setEmailError("Invalid Request, Please try again");

            axios.post(`${baseUrl}validate-email?apiKey=${authKey}&email=${inputEmail}&service=zerobounce`, {
                    token: props.token
            },{
                headers: {
                    "Accept": "application/json",
                    "Authorization": authKey
                }
            }).then((res) => {

                const response = JSON.parse(res.data.response);
                setServiceType(res.data.service);
                setEmailData([response]);
            }).catch((err) => {
                setEmailError(err.response.data.errorMessage)
                // setEmailData([""])
                setDailyQuotaError(false)
            }).finally(() => {
                setIsLoading(false);
                props.renewToken()
            })

        }
        else (
            setIsVaildMail("Please enter a valid mail address.")
        )

        setTimeout(() => {
            setIsVaildMail("")
        }, 8000)

    }


  console.log(dailyQuotaError, "emailData.length");
    return (
        <section className="section h-100 pt-3">

            {/* <GoogleReCaptchaProvider reCaptchaKey="6LdrF8kiAAAAADJ7-rqIJCGYCBRd-ovwegtYiLOj">
                <YourReCaptchaComponent />
            </GoogleReCaptchaProvider> */}


            <div className="container d-flex justify-content-center h-100">

                <div className="row justify-content-center text-center pb-3 pt-4 section">
                    <div className="col-12 col-md-12">


                        <div className="email-vaildator-form">
                        
                            <InputGroup>
                                <Form.Control
                                    className="text-lowercase"
                                    placeholder="example@gmail.com"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2"
                                    ref={ref}
                                    value={inputEmail}
                                    onChange={(e) => setInputEmail(e.target.value)}
                                    onKeyPress={(ev, e) => {
                                        if (ev.key === "Enter") {handleData()  }
                                    }}
                                />
                                <Button className={`ms-3 ${inputEmail.length > 0 && !isLoading ? "" : "disabled"}`} onClick={handleData}>
                                    Verify
                                </Button>
                            </InputGroup>                            
                            {isVaildMail.length > 0 ? (
                                <Form.Label className="mt-2 text-danger mb-0">Please enter a valid mail address</Form.Label>
                            ) :
                                <>
                                    {emailError.length > 0 ? (
                                        <Form.Label className="mt-2 text-danger mb-0">{emailError}</Form.Label>
                                    ) : null}
                                </>
                            }
                        </div>
                        <div className="my-4 d-flex align-items-center gap-3" role="alert">
                            <p className="mb-0" style={{ fontSize: "18px" }}>
                                <span className="fw-semibold fs-16">Want to validate multiple emails at once?</span>
                                <span className="mx-1">👉</span>
                                Sign up with <a href="https://www.engagebay.com/signup" target="_blank" rel="noreferrer" role="button" style={{ textDecoration: "none" }}
                                    aria-label="Sign up for EngageBay"><span className="fw-semibold">EngageBay</span></a> to access bulk email validation.
                            </p>
                            {/* <a
                                className="btn btn-outline-primary btn-sm"
                                href="https://www.engagebay.com/signup"
                                target="_blank"
                                rel="noopener noreferrer"
                                role="button"
                                aria-label="Sign up for EngageBay"
                            >
                                Sign up
                            </a> */}
                        </div>
                        {isLoading ? (
                            <span className="p-3 text-start">
                                <span className="p-3">
                                    <img src="https://doxhze3l6s7v9.cloudfront.net/app/static//img/ajax-loader-cursor.gif" alt="gif" />
                                </span>
                            </span>
                        ) : (
                            <>
                                {
                                    emailData.length && dailyQuotaError ? (
                                        <>
                                            {serviceType === "mailgun" ? (
                                                <div className="card p-5 rounded email-vaildator-card">
                                                    <div className="email-box">
                                                        <p className="mb-0 text-lowercase">
                                                            {inputEmail}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        {emailData.map((data, index) => {
                                                            return (
                                                                <div key={index} className="row text-start" >
                                                                    <div className="col-md-6 col-lg-6 mb-3">
                                                                        <p className="mb-2 result-label">Mail Address</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p>{data.address ? data.address : "Unknown"}</p>
                                                                        </div>
                                                                    </div>
                                                                    {data.did_you_mean ? (
                                                                        <div className="col-md-6 col-lg-6 mb-3">
                                                                            <p className="mb-2 result-label">Did You Mean? : </p>
                                                                            <div className="result-value text-truncate">
                                                                                <p>{`${data.did_you_mean ? data.did_you_mean : "Unknown"}`}</p>
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                    <div className="col-md-6 col-lg-6 mb-3">
                                                                        <p className="mb-2 result-label">Is Disposable:</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.is_disposable_address ? data.is_disposable_address : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-6 mb-3">
                                                                        <p className="mb-2 result-label">Is Role Address:</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.is_disposable_address ? data.is_disposable_address : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-6 mb-3">
                                                                        <p className="mb-2 result-label">Results : </p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.result ? data.result : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 col-lg-6 mb-3">
                                                                        <p className="mb-2 result-label">Risk : </p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.risk ? data.risk : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    {data.reason ? (
                                                                        <>
                                                                            <div className="col-md-12 col-lg-12 result-label">
                                                                                <p>Reasons :</p>
                                                                            </div>
                                                                            <div>
                                                                                {data.reason.map((reasonsList) => {
                                                                                    return (
                                                                                        <ul key={index}>
                                                                                            <li>
                                                                                                {reasonsList}
                                                                                            </li>
                                                                                        </ul>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="card p-5 rounded email-vaildator-card">
                                                    <div className="email-box">
                                                        <p className="mb-0 text-lowercase">
                                                            {inputEmail}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        {emailData.map((data, index) => {
                                                            console.log(data.free_email, "data.free_email");
                                                            return (
                                                                <div key={index} className="row text-start" >
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Status</p>
                                                                        <div className="result-value text-truncate border-warning">
                                                                            <p className="text-capitalize">{data.status ? data.status : "UnKnown"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Sub Status</p>
                                                                        <div className="result-value text-truncate border-warning">
                                                                            <p>{data.sub_status ? data.sub_status : "Unknown"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Free Email </p>
                                                                        <div className="result-value text-truncate">
                                                                            <p className="text-capitalize">{`${data.free_email}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Did you mean</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.did_you_mean ? data.did_you_mean : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Account</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.account ? data.account : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Domain </p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.domain ? data.domain : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Domain Age Days</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.domain_age_days ? data.domain_age_days : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">smtp provider</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.smtp_provider ? data.smtp_provider : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">mx Found</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p className="text-capitalize"> {`${data.mx_found} `}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">mx Record</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.mx_record ? data.mx_record : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Firstname</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.firstname ? data.firstname : "Unknown"}`}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 col-lg-4 mb-3">
                                                                        <p className="mb-2 result-label">Lastname</p>
                                                                        <div className="result-value text-truncate">
                                                                            <p> {`${data.lastname ? data.lastname : "Unknown"} `}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : null
                                }
                            </>

                        )}


                    </div>
                </div>

            </div>
        </section >
        
    );
    
}


export default EmailVaildator